(() => {
  // PROMO VUELTA AL COLE 2026
  // Elegibles base: 185 variantes Niño + 155 variantes Niña = 340 variantes.
  // Packs confirmados: 25 productos con Type = Pack, detectados por handle (13 Niño + 12 Niña).
  // 1 pack adicional activo/publicado con Type vacío queda fuera hasta confirmación.
  // Excluidos base: 8 Unisex + 1 Hombre.
  // Regla: 1 set de lapiceros correspondiente por cada unidad elegible.

  const PROMO_ACTIVE = true;

  const BOY_ELIGIBLE_VARIANT_IDS = new Set([
    57511825932613, // AJ52ALC001-2510-6YIL
    57511634862405, // AJ52BGA001-2420-7C6L
    57511827079493, // AJ52CHP001-2616-1G8L
    57511665631557, // AJ52DBT001-2510-6RXL
    57511634403653, // AJ52DIG001-2616-6L9L
    57511672152389, // AJ52DNL001-2510-7YPL
    57628866937157, // AJ52DGL001-2510-1K6L
    57511754203461, // AJ52GRP001-2526-7YQL
    57511673299269, // AJ52HEM001-2510-NZ0L
    57511667204421, // AJ52LSU001-2420-7Y5L
    57622069608773, // AJ52MGD001-2510-6DJL
    57511675953477, // AJ52MRC001-2510-7CXL
    57511714914629, // AJ52MLT001-2510-7Y9L
    57511793164613, // AJ52RXD001-2420-6D7L
    57511828717893, // AJ52CHP003-2616-1G8M
    57511793557829, // AJ52SNL001-2510-7Y8L
    57553459577157, // AJ52SKL002-2616-0RNM
    57553459642693, // AJ52SKL002-2616-4FLM
    57553459773765, // AJ52SKL002-2616-8VYM
    57553459806533, // AJ52SKL002-2616-N01M
    57511690961221, // AJ52SPB001-2420-6RRL
    57511721009477, // AJ52STU001-2616-0G7L
    57511764164933, // AJ52VOR002-2616-5ERL
    57621819392325, // AC52ECO009-2526Z-0G8
    57621819490629, // AC52ECO009-2526Z-2EC
    57621819523397, // AC52ECO009-2526Z-5L4
    57621819720005, // AC52ECO009-2616Z-0RN
    57621819785541, // AC52ECO009-2616Z-4FL
    57621819949381, // AC52ECO009-2616Z-7EM
    58307284959557, // AC52ECO009-2616Z-8E7
    57851213513029, // AC52ECO009-2426Z-0JI
    57851213480261, // AC52ECO009-2426Z-0JJ
    57851213447493, // AC52ECO009-2426Z-0JK
    57851213283653, // AC52ECO009-2426Z-6YW
    57851213250885, // AC52ECO009-2426Z-6YY
    57851213218117, // AC52ECO009-2426Z-7CF
    57851213185349, // AC52ECO009-2426Z-7CG
    57851213152581, // AC52ECO009-2426Z-7Y6
    58084369432901, // AC52ECO009-2516Z-0G6
    58084369170757, // AC52ECO009-2516Z-6DS
    58084369137989, // AC52ECO009-2516Z-6DT
    58084369072453, // AC52ECO009-2516Z-7YJ
    58084369039685, // AC52ECO009-2516Z-7YK
    58084369006917, // AC52ECO009-2516Z-7YL
    58084368974149, // AC52ECO009-2516Z-8C5
    58084385161541, // AC52ECO003-2516Z-4EC
    58084385063237, // AC52ECO003-2516Z-6DS
    58084385030469, // AC52ECO003-2516Z-6DT
    58084384964933, // AC52ECO003-2516Z-7YJ
    58084384932165, // AC52ECO003-2516Z-7YK
    58084384899397, // AC52ECO003-2516Z-7YL
    58084384866629, // AC52ECO003-2516Z-8C5
    58084384833861, // AC52ECO003-2516Z-8FK
    57553444962629, // AC52ECO012-2526Z-0G8
    57553445060933, // AC52ECO012-2526Z-2EC
    57553445126469, // AC52ECO012-2526Z-5L4
    57553445159237, // AC52ECO012-2526Z-5L7
    58709694775621, // AC52ECO012-2616Z-0RN
    58709694611781, // AC52ECO012-2616Z-4GF
    58709694677317, // AC52ECO012-2616Z-4GS
    58709694513477, // AC52ECO012-2616Z-7EM
    58709694906693, // AC52ECO012-2616Z-8E7
    58709694939461, // AC52ECO012-2616Z-8VY
    57851215282501, // AC52ECO012-2426Z-0JI
    57851215249733, // AC52ECO012-2426Z-0JJ
    57851215216965, // AC52ECO012-2426Z-0JK
    57851215184197, // AC52ECO012-2426Z-0JN
    57851215053125, // AC52ECO012-2426Z-6YW
    57851215020357, // AC52ECO012-2426Z-6YY
    57851214987589, // AC52ECO012-2426Z-7CF
    57851214954821, // AC52ECO012-2426Z-7CG
    57851214922053, // AC52ECO012-2426Z-7Y6
    58084371988805, // AC52ECO012-2516Z-0G6
    58084371890501, // AC52ECO012-2516Z-4EC
    58084371792197, // AC52ECO012-2516Z-6DS
    58084371759429, // AC52ECO012-2516Z-6DT
    58084371693893, // AC52ECO012-2516Z-7YJ
    58084371661125, // AC52ECO012-2516Z-7YK
    58084371628357, // AC52ECO012-2516Z-7YL
    58084371595589, // AC52ECO012-2516Z-8C5
    58084371562821, // AC52ECO012-2516Z-8FK
    58084371530053, // AC52ECO012-2516Z-Z3A
    57553454104901, // MA04ECO021-2526N-0G8
    57553454170437, // MA04ECO021-2526N-2EC
    57553454235973, // MA04ECO021-2526N-5L4
    57553454268741, // MA04ECO021-2526N-5LC
    58709692842309, // MA04ECO021-2616N-0RN
    58709692940613, // MA04ECO021-2616N-4GF
    58709692809541, // MA04ECO021-2616N-4GS
    58709692776773, // MA04ECO021-2616N-7EM
    58709693137221, // MA04ECO021-2616N-8E7
    58709693169989, // MA04ECO021-2616N-8VY
    58084376412485, // MA04ECO021-2516N-0G6
    58084376150341, // MA04ECO021-2516N-6DS
    58084376117573, // MA04ECO021-2516N-6DT
    58084376052037, // MA04ECO021-2516N-7YJ
    58084376019269, // MA04ECO021-2516N-7YK
    58084375986501, // MA04ECO021-2516N-7YL
    58084375953733, // MA04ECO021-2516N-8C5
    58084375888197, // MA04ECO021-2516N-Z3A
    57553447616837, // MA03ECO014-25260-5L4
    57553447649605, // MA03ECO014-25260-5L7
    57553447682373, // MA03ECO014-25260-5LC
    58709690679621, // MA03ECO014-26160-0RN
    58709690777925, // MA03ECO014-26160-4FL
    58709690745157, // MA03ECO014-26160-4GF
    58709690810693, // MA03ECO014-26160-4GS
    58709690843461, // MA03ECO014-26160-7EM
    58709690974533, // MA03ECO014-26160-8E7
    58709691007301, // MA03ECO014-26160-8VY
    57851210498373, // MA03ECO014-24160-6YB
    58084362551621, // MA03ECO014-25160-4EC
    58084362355013, // MA03ECO014-25160-7YK
    58084362322245, // MA03ECO014-25160-7YL
    58084362289477, // MA03ECO014-25160-8C5
    58510823424325, // MA04ECO002-2516N-7YK
    57622077178181, // MA04ECO002-2526N-5L4
    58709702934853, // MA04ECO002-2616N-0RN
    58709702902085, // MA04ECO002-2616N-4FL
    58709702869317, // MA04ECO002-2616N-4GS
    58709702705477, // MA04ECO002-2616N-7EM
    58709702803781, // MA04ECO002-2616N-8E7
    58709702967621, // MA04ECO002-2616N-8VY
    58084328833349, // MA04ECO002-2516N-0G6
    58084328636741, // MA04ECO002-2516N-6DS
    58084328603973, // MA04ECO002-2516N-6DT
    58084328472901, // MA04ECO002-2516N-7YL
    58084328440133, // MA04ECO002-2516N-8C5
    58084328407365, // MA04ECO002-2516N-8FK
    58510833549637, // MA03ECO006-2516P-7YJ
    58510833516869, // MA03ECO006-2516P-7YK
    57683455705413, // MA03ECO006-2526P-0G8
    57683455803717, // MA03ECO006-2526P-2EC
    58709805891909, // MA03ECO006-2616P-0RN
    58709806154053, // MA03ECO006-2616P-4FL
    58709806121285, // MA03ECO006-2616P-4GF
    58709806088517, // MA03ECO006-2616P-4GS
    58709806022981, // MA03ECO006-2616P-7EM
    58709806252357, // MA03ECO006-2616P-8E7
    58709806285125, // MA03ECO006-2616P-8VY
    58084125245765, // MA03ECO006-2516P-0G6
    58084124852549, // MA03ECO006-2516P-4EC
    58084125147461, // MA03ECO006-2516P-6DS
    58084125114693, // MA03ECO006-2516P-6DT
    58084124983621, // MA03ECO006-2516P-7YL
    58084124950853, // MA03ECO006-2516P-8C5
    58084124885317, // MA03ECO006-2516P-Z3A
    58709906227525, // AC61ECO007-2526Z-5L4
    58084381229381, // AC61ECO007-2516Z-7YJ
    58084381163845, // AC61ECO007-2516Z-7YL
    57511686603077, // MJ04ALC002-2510-6YIM
    57553490477381, // MJ04BGA002-2420-7C6M
    57553490444613, // MJ04BGA002-2420-7CRM
    57511965753669, // MJ04CHP002-2616-1G8M
    57511899332933, // MJ03CHP003-2616-1G8L
    57511899365701, // MJ03CHP005-2616-1G8M
    58336378749253, // MJ03DBT005-2510-6RXM
    57511847493957, // MJ03DIG005-2616-6L9M
    57511848182085, // MJ03GRP005-2526-7YQM
    57628865724741, // MJ03HNZ005-2526-6NRM
    57511901102405, // MJ03HEM005-2510-NZ0M
    57511693353285, // MJ03LSU005-2420-7Y5M
    57511695286597, // MJ03MRC003-2510-7CXL
    58108520104261, // MJ03MRC005-2510-7CXM
    57622128951621, // MJ03MLT005-2510-7Y9M
    57628848456005, // MJ03SNL005-2510-7Y8M
    57553481892165, // MJ03SKL003-2616-0RNL
    57553481957701, // MJ03SKL003-2616-4FLL
    57628973072709, // MJ03SKL003-2616-6CSL
    57553482088773, // MJ03SKL003-2616-8VYL
    57553482121541, // MJ03SKL003-2616-N01L
    58336378716485, // MJ03SPB005-2420-6RRM
    57511650361669, // MJ03STU005-2616-0G7M
    57511745585477, // MJ03VOR005-2616-5ERM
    57511913324869, // MJ03RXD005-2420-6D7M
    58135646961989, // MJ03RXD006-2420-6D7L
    57511744438597, // MJ04DIG002-2616-6L9M
    57628954001733, // MJ04GRP002-2526-7YQM
    57511699284293, // MJ04MRC002-2510-7CXM
    58108585574725, // MJ04MLT001-2510-7Y9S
    57511967392069, // MJ04MLT002-2510-7Y9M
    58135749656901, // MJ04RXD002-2420-6D7M
    57511704985925, // MJ04SPB002-2420-6RRM
    57511927775557, // MJ04STU002-2616-0G7M
    57511654424901, // MJ04VOR002-2616-5ERM
  ]);

  const GIRL_ELIGIBLE_VARIANT_IDS = new Set([
    57511826456901, // AJ52BAB001-2616-5MEL
    57628867526981, // AJ52BNP001-2526-3LVL
    58709683011909, // AJ52CLW001-2616-MM0M
    57511665795397, // AJ52FNS001-2420-4QKL
    57511830880581, // AJ52FRP001-2616-6M7L
    57628871131461, // AJ52GLW001-2510-5QBL
    57673927459141, // AJ52MGT001-2410-5D5U
    57511784874309, // AJ52MLL001-2510-7YML
    57511677067589, // AJ52QCT001-2510-1K5L
    57511668482373, // AJ52RAS001-2526-1KFL
    57511793099077, // AJ52REF001-2510-9JDL
    57511764066629, // AJ52UNK003-2616-0AQU
    57511717404997, // AJ52MJT001-2510-P3UL
    57511723204933, // AJ52SNY001-2510-4QUL
    57553459609925, // AJ52SKL002-2616-0S7M
    57553459675461, // AJ52SKL002-2616-4IXM
    57553459708229, // AJ52SKL002-2616-5MGM
    57553459740997, // AJ52SKL002-2616-7EZM
    57511786119493, // AJ52UNK001-2616-0AQL
    57511724024133, // AJ52USP001-2420-4QLL
    57621819326789, // AC52ECO009-2521Z-0IN
    57621819359557, // AC52ECO009-2521Z-0LF
    57621819425093, // AC52ECO009-2526Z-0LG
    57621819621701, // AC52ECO009-252DZ-0S6
    57621819654469, // AC52ECO009-2611Z-3FW
    57621819687237, // AC52ECO009-2611Z-4FE
    57621819752773, // AC52ECO009-2616Z-0S7
    57621819883845, // AC52ECO009-2616Z-4IX
    57621819916613, // AC52ECO009-2616Z-5MG
    57621819982149, // AC52ECO009-2616Z-7EZ
    57851213578565, // AC52ECO009-2421Z-M19
    57851213545797, // AC52ECO009-2426Z-0JG
    58084369400133, // AC52ECO009-2516Z-1FY
    58084369367365, // AC52ECO009-2516Z-1KC
    58084369236293, // AC52ECO009-2516Z-5Q5
    58084385194309, // AC52ECO003-2516Z-1KC
    58084385128773, // AC52ECO003-2516Z-5Q5
    58084385096005, // AC52ECO003-2516Z-5Q8
    58709694873925, // AC52ECO012-2521Z-0IN
    57553444897093, // AC52ECO012-2521Z-0LF
    57553444995397, // AC52ECO012-2526Z-0LG
    57553445028165, // AC52ECO012-2526Z-1IN
    57553445192005, // AC52ECO012-2526Z-8UY
    57553445224773, // AC52ECO012-252DZ-0S6
    58709694841157, // AC52ECO012-2611Z-3FW
    58709694808389, // AC52ECO012-2611Z-4FE
    58709694579013, // AC52ECO012-2616Z-0S7
    58709694546245, // AC52ECO012-2616Z-4IX
    58709694710085, // AC52ECO012-2616Z-5MG
    58709694644549, // AC52ECO012-2616Z-7EZ
    57851215315269, // AC52ECO012-2426Z-0JG
    57851215085893, // AC52ECO012-2426Z-6YV
    58084372087109, // AC52ECO012-2511Z-1KB
    58084372021573, // AC52ECO012-2516Z-0FB
    58084371956037, // AC52ECO012-2516Z-1FY
    58084371923269, // AC52ECO012-2516Z-1KC
    58084371857733, // AC52ECO012-2516Z-5Q5
    58084371824965, // AC52ECO012-2516Z-5Q8
    58084371726661, // AC52ECO012-2516Z-7YI
    58709693104453, // MA04ECO021-2521N-0IN
    57553454072133, // MA04ECO021-2521N-0LF
    57553454203205, // MA04ECO021-2526N-4MM
    57553454334277, // MA04ECO021-252DN-0S6
    58709693038917, // MA04ECO021-2611N-3FW
    58709693071685, // MA04ECO021-2611N-4FE
    58709693006149, // MA04ECO021-2616N-0S7
    58709692744005, // MA04ECO021-2616N-4IX
    58709692907845, // MA04ECO021-2616N-5MG
    58709692875077, // MA04ECO021-2616N-7EZ
    57851216789829, // MA04ECO021-2426N-6YV
    58084376510789, // MA04ECO021-2511N-1KB
    58084376445253, // MA04ECO021-2516N-0FB
    58084376379717, // MA04ECO021-2516N-1FY
    58084376346949, // MA04ECO021-2516N-1KC
    58084376215877, // MA04ECO021-2516N-5Q5
    58084376183109, // MA04ECO021-2516N-5Q8
    58084376084805, // MA04ECO021-2516N-7YI
    58709690941765, // MA03ECO014-25210-0IN
    58709690876229, // MA03ECO014-26110-3FW
    58709690908997, // MA03ECO014-26110-4FE
    58709690646853, // MA03ECO014-26160-4IX
    58709690614085, // MA03ECO014-26160-5MG
    58709690712389, // MA03ECO014-26160-7EZ
    58084362682693, // MA03ECO014-25110-5Q6
    58084362584389, // MA03ECO014-25160-1KC
    58084362518853, // MA03ECO014-25160-5Q5
    58510823489861, // MA04ECO002-2516N-5Q5
    57622077047109, // MA04ECO002-2521N-0IN
    57622077112645, // MA04ECO002-2526N-1IN
    57622077309253, // MA04ECO002-252DN-0S6
    58709703098693, // MA04ECO002-2611N-3FW
    58709703033157, // MA04ECO002-2611N-4FE
    58709702836549, // MA04ECO002-2616N-0S7
    58709702738245, // MA04ECO002-2616N-4IX
    58709703000389, // MA04ECO002-2616N-5MG
    58709702771013, // MA04ECO002-2616N-7EZ
    57851211514181, // MA04ECO002-2426N-4QR
    58084328931653, // MA04ECO002-2511N-1KB
    58084328866117, // MA04ECO002-2516N-0FB
    58084328800581, // MA04ECO002-2516N-1FY
    58084328767813, // MA04ECO002-2516N-1KC
    58084328669509, // MA04ECO002-2516N-5Q8
    58084328571205, // MA04ECO002-2516N-7YI
    58510833582405, // MA03ECO006-2516P-5Q5
    57683455607109, // MA03ECO006-2521P-0IN
    57931781570885, // MA03ECO006-2521P-0LF
    57683455738181, // MA03ECO006-2526P-0LG
    57683455770949, // MA03ECO006-2526P-1IN
    57683456000325, // MA03ECO006-252DP-0S6
    58709806219589, // MA03ECO006-2611P-3FW
    58709806186821, // MA03ECO006-2611P-4FE
    58709805990213, // MA03ECO006-2616P-0S7
    58709806055749, // MA03ECO006-2616P-4IX
    58709805924677, // MA03ECO006-2616P-5MG
    58709805957445, // MA03ECO006-2616P-7EZ
    58084124787013, // MA03ECO006-2516P-1FY
    58084124819781, // MA03ECO006-2516P-1KC
    58084125081925, // MA03ECO006-2516P-7YI
    58307442901317, // MJ04BOM002-2616-8LDM
    58315630313797, // MJ04BNP002-2526-3LVM
    57553465442629, // MJ04CLW002-2420-ZG0M
    58709690024261, // MJ04CLW002-2526-MP0M
    58709689958725, // MJ04CLW002-2616-MM0M
    58709689991493, // MJ04CLW002-2616-VV0M
    57621911470405, // MJ03ALC005-2510-6YIM
    57511812596037, // MJ03BOM003-2616-8LDL
    57628871524677, // MJ03BNP005-2526-3LVM
    57511647215941, // MJ03FRP005-2616-6M7M
    57511945929029, // MJ03GLO005-2616-0N5M
    57628872245573, // MJ03GLW003-2510-5QBL
    57511647707461, // MJ03MGD003-2510-6DJL
    58109259743557, // MJ03MGD005-2510-6DJM
    57621914321221, // MJ03MJT005-2510-P3UM
    57511647805765, // MJ03RAS005-2526-1KFM
    57553481924933, // MJ03SKL003-2616-0S7L
    57553481990469, // MJ03SKL003-2616-4IXL
    57628973039941, // MJ03SKL003-2616-4QHL
    57553482023237, // MJ03SKL003-2616-5MGL
    57628973105477, // MJ03SKL003-2616-6YVL
    57553482056005, // MJ03SKL003-2616-7EZL
    57628977922373, // MJ03UNK003-2616-0AQL
    57511962870085, // MJ03UNK005-2616-0AQM
    57553490641221, // MJ04FNS002-2420-4QKM
    58135748870469, // MJ04FNS002-2420-4QMM
    57511689388357, // MJ04FRP002-2616-6M7M
    57511652655429, // MJ04ICP002-2420-0KOM
    58315630018885, // MJ04LSU002-2420-7Y5M
    58108584460613, // MJ04MGD001-2510-6DJS
    57511701709125, // MJ04MGD002-2510-6DJM
    57628869165381, // MJ04RAS002-2526-1KFM
    57511704068421, // MJ04RXD002-2420-7Y1M
    57547640930629, // MJ04UNK002-2616-0AQM
    57628931588421, // MJ04UNK003-2616-0AQL
    57511798800709, // MJ03BAB003-2616-5MEL
    57511687291205, // MJ04BAB002-2616-5MEM
  ]);

  // Packs Niño confirmados: detección por handle.
  const BOY_ELIGIBLE_PACK_HANDLES = new Set([
    'gr',
    'mj04dig002-pck-6l9m-n01',
    'mj04grp002-2526-7yqm',
    'pack-escolar-nina-rainbow-star-mochila-con-ruedas-estuche-botella-de-550ml-1',
    'pack-escolar-nino-digisaurio-mochila-con-ruedas-estuche-botella-de-550ml',
    'pack-escolar-nino-mochila-con-ruedas-3-accesorios',
    'pack-escolar-nino-mochila-con-ruedas-desmontable-tiza-estuche-3-compartimentos-agapec-botella-de-550ml',
    'pack-escolar-nino-mochila-con-ruedas-estuche-3-compartimentos-1',
    'pack-escolar-nino-stardust-mochila-estuche-botella-de-550ml',
    'pack-escolar-nino-vortex-mochila-con-ruedas-estuche-botella-de-550ml',
    'pack-escolar-nino-vortex-mochila-estuche-botella-de-550ml',
    'pack-escolar-polar-mochila-con-ruedas-desmontable-estuche-3-compartimentos',
    'pack-escolar-prisma-mochila-sin-ruedas-estuche-2-compartimentos',
  ]);

  // Packs Niña confirmados: detección por handle.
  const GIRL_ELIGIBLE_PACK_HANDLES = new Set([
    'pack-escolar-nina-bunny-pump-mochila-con-ruedas-estuche-botella-de-550ml',
    'pack-escolar-nina-mochila-con-ruedas-desmontable-tiza-estuche-3-compartimentos-agapec-botella-de-550ml',
    'pack-escolar-nina-mochila-con-ruedas-renglones-estuche-3-compartimentos-agapec-botella-de-550ml',
    'pack-escolar-nina-rainbow-star-mochila-con-ruedas-estuche-botella-de-550ml',
    'pack-escolar-nina-rainbow-star-mochila-estuche-botella-de-550ml',
    'pack-escolar-nina-unicorn-kisses-mochila-con-ruedas-estuche-botella-de-550ml',
    'pack-escolar-nino-friends-party-mochila-con-ruedas-estuche-botella-de-550ml',
    'pack-escolar-nino-friends-party-mochila-estuche-botella-de-550ml',
    'pack-escolar-nino-friends-party-mochila-estuche-botella-de-550ml-1',
    'pack-escolar-nino-grand-prix-mochila-estuche-botella-de-550ml',
    'pack-escolar-shiny-heart-mochila-con-ruedas-desmontable-estuche-3-compartimentos',
    'pack-escolar-shiny-heart-mochila-estuche-2-compartimentos',
  ]);

  const LEGACY_FOLDER_VARIANT_ID = 58307284730181; // AI37-00373-N01 · retirar de carritos antiguos
  const BOY_GIFT_VARIANT_ID = 58275793142085;      // AI37-00396-5HR
  const GIRL_GIFT_VARIANT_ID = 58275801366853;      // AI37-00393-0K0

  const PROMO_PROPERTY = '_promo_kit_escolar';
  const PROMO_VALUE = 'vuelta_cole_2026';
  const COMPONENT_PROPERTY = '_promo_componente';

  const ROOT = window.Shopify?.routes?.root || '/';

  let syncing = false;
  let syncTimer = null;

  function scheduleSync(delay = 150) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, delay);
  }

  async function getCart() {
    const response = await fetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('No se ha podido leer el carrito');
    return response.json();
  }

  function getCartDrawerSectionId() {
    return (
      document
        .querySelector('hdt-cart-drawer[section-id]')
        ?.getAttribute('section-id') || null
    );
  }

  async function postCart(endpoint, payload, sectionId = null) {
    const body = { ...payload };

    if (sectionId) {
      body.sections = [sectionId];
      body.sections_url = window.location.pathname + window.location.search;
    }

    const response = await fetch(ROOT + `cart/${endpoint}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Error actualizando el carrito'
      );
    }

    return data;
  }

  function refreshCartDrawer(html) {
    if (!html) return;

    const currentDrawer = document.querySelector('hdt-cart-drawer');
    if (!currentDrawer) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = parsed.querySelector('hdt-cart-drawer');
    if (!freshDrawer) return;

    const selectors = [
      '[ref="shipping-bar"]',
      '[ref="cart-items"]',
      '[ref="cart-bottom"]'
    ];

    selectors.forEach((selector) => {
      const current = currentDrawer.querySelector(selector);
      const fresh = freshDrawer.querySelector(selector);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    });

    const newCount = freshDrawer.getAttribute('data-count');
    if (newCount !== null) {
      currentDrawer.setAttribute('data-count', newCount);
    }
  }

  function targetQuantities(cart) {
    let boyQuantity = 0;
    let girlQuantity = 0;

    cart.items.forEach((item) => {
      const variantId = Number(item.variant_id);
      const handle = item.handle || '';

      const isBoyEligible =
        BOY_ELIGIBLE_VARIANT_IDS.has(variantId) ||
        BOY_ELIGIBLE_PACK_HANDLES.has(handle);

      const isGirlEligible =
        GIRL_ELIGIBLE_VARIANT_IDS.has(variantId) ||
        GIRL_ELIGIBLE_PACK_HANDLES.has(handle);

      if (isBoyEligible) {
        boyQuantity += item.quantity;
      }

      if (isGirlEligible) {
        girlQuantity += item.quantity;
      }
    });

    if (!PROMO_ACTIVE) {
      boyQuantity = 0;
      girlQuantity = 0;
    }

    return {
      boyQuantity,
      girlQuantity
    };
  }

  function getGiftLines(cart, variantId) {
    return cart.items.filter(
      (item) => Number(item.variant_id) === variantId
    );
  }

  function prepareGiftSync(cart, variantId, targetQuantity, component, updates, additions) {
    const lines = getGiftLines(cart, variantId);
    const currentQuantity = lines.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    if (targetQuantity > 0 && lines.length === 0) {
      additions.push({
        id: variantId,
        quantity: targetQuantity,
        properties: {
          [PROMO_PROPERTY]: PROMO_VALUE,
          [COMPONENT_PROPERTY]: component
        }
      });
      return;
    }

    if (
      lines.length > 0 &&
      (currentQuantity !== targetQuantity || lines.length > 1)
    ) {
      lines.forEach((item, index) => {
        updates[item.key] = index === 0 ? targetQuantity : 0;
      });
    }
  }

  async function syncCart() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();
      const { boyQuantity, girlQuantity } = targetQuantities(cart);

      const updates = {};
      const additions = [];

      // Limpieza de carritos iniciados antes del cambio de mecánica:
      // si todavía contienen la carpeta promocional, se elimina.
      prepareGiftSync(
        cart,
        LEGACY_FOLDER_VARIANT_ID,
        0,
        'carpeta',
        updates,
        additions
      );

      prepareGiftSync(
        cart,
        BOY_GIFT_VARIANT_ID,
        boyQuantity,
        'nino',
        updates,
        additions
      );

      prepareGiftSync(
        cart,
        GIRL_GIFT_VARIANT_ID,
        girlQuantity,
        'nina',
        updates,
        additions
      );

      const sectionId = getCartDrawerSectionId();
      let result = null;

      if (Object.keys(updates).length > 0) {
        result = await postCart(
          'update',
          { updates },
          sectionId
        );
      }

      if (additions.length > 0) {
        result = await postCart(
          'add',
          { items: additions },
          sectionId
        );
      }

      if (
        result &&
        sectionId &&
        result.sections &&
        result.sections[sectionId]
      ) {
        refreshCartDrawer(result.sections[sectionId]);
      }

      if (
        result &&
        !sectionId &&
        window.location.pathname.replace(/\/$/, '').endsWith('/cart')
      ) {
        window.location.reload();
      }
    } catch (error) {
      console.error('[Promo Kit Escolar]', error);
    } finally {
      syncing = false;
    }
  }

  function observeCartDrawer() {
    const drawer = document.querySelector('hdt-cart-drawer');
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      scheduleSync(100);
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener(
    'shopify:cart:lines-update',
    () => scheduleSync(100)
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('form');
      if (!form) return;

      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add')) {
        scheduleSync(600);
      }
    },
    true
  );

  function init() {
    observeCartDrawer();
    scheduleSync(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
